const app = {
  dbName: process.env.VUE_APP_DB_NAME,
  delayTime: process.env.VUE_APP_DELAY_TIME,
};

export { app };
